import React from 'react';
import { Chip, styled } from '@mui/material';
import { SvgIcon } from 'components/SvgIcon/SvgIcon';
import { ReactComponent as CareProgramIcon } from 'assets/icons/CareProgramIcon.svg';
import { color } from 'themes/color';

const StyledChip = styled(Chip)(({ theme }) => ({
  '&.MuiChip-root': {
    backgroundColor: theme.palette.extendedPrimary1.main,
    alignSelf: 'flex-start',
  },
  '.MuiChip-icon': { marginLeft: '10px' },
}));

interface CareProgramChipProps {
  careProgramName: string;
  ariaDescriptionId?: string;
}

export const CareProgramChip = ({ careProgramName, ariaDescriptionId }: CareProgramChipProps) => (
  <StyledChip
    className="care-program-chip"
    icon={
      <SvgIcon
        className="care-program-chip__icon"
        component={CareProgramIcon}
        color="primary"
        aria-hidden="true"
      />
    }
    id={ariaDescriptionId}
    aria-label={`Care Program: ${careProgramName}`}
    label={careProgramName}
    classes={{ label: 'care-program-chip__label' }}
  />
);
